import { render, staticRenderFns } from "./OptionsmMenu.vue?vue&type=template&id=712f5204&scoped=true&"
import script from "./OptionsmMenu.vue?vue&type=script&lang=js&"
export * from "./OptionsmMenu.vue?vue&type=script&lang=js&"
import style0 from "./OptionsmMenu.vue?vue&type=style&index=0&id=712f5204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712f5204",
  null
  
)

export default component.exports